<template>
    <div class="dailyScheduleVue" v-loading.fullscreen.lock="loadingModal">
        <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-8">
                    <h1 class="h1">Daily Schedule</h1>
                    <h2 class="h2 ml-15">Total Jobs: {{ total_jobs }}</h2>
                    <h2 class="h2 ml-15">Total Calls: {{ total_calls }}</h2>
                </div>
                <div class="col-md-4 text-right">
                    <ul class="o-filter-area d-flex flex-row">
                        <li v-if="componentName=='DailySchedule'">
                            <a @click="toggleComponent('AllEmployees')" href="javascript: void(0)" class="c-common-btn c-solid-btn--small print-button">All Employees</a>

                        </li>
                        <li v-if="componentName=='AllEmployees'">
                            <a @click="toggleComponent('DailySchedule')" href="javascript: void(0)" class="c-common-btn c-solid-btn--small print-button">Daily Schedule</a>
                        </li>
                        <li class="o-search-field">
                            <div class="input-group stylish-input-group">
                                <input v-on:keyup="getDailyScheduleList()" v-model="searchData" type="text" class="form-control" placeholder="Search">
                                <span class="input-group-addon">
                                    <button type="submit">
                                    <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="o-ndividualArea c-responsive-fixwidth">

            <div class="o-ndividualTable">

                <div class="row">
                    <div class="col-sm-12 c-common-space">
                        <div class="filesLisBoxTitle pad-25">
                            <div class="d-fex h5 o-daily-schedule-navigation">
                                <span>Date:</span>
                                <span class="m-0">
                                    <a class="m-0" title="Previous Day" @click="previousDay()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                                </span>
                                <label class="m-0 o-inline-datepicker">
                                    <el-date-picker
                                        class="o-inline-datepicker-icon width-220"
                                        type="date"
                                        @change="onDateChange"
                                        v-model="currentDate"
                                        :format="getDisplayFormat()"
                                        value-format="yyyy-MM-dd"
                                        :placeholder="getDatePlaceholder()">
                                    </el-date-picker>
                                </label>
                                <span class="m-0">
                                    <a class="m-0" title="Next Day" @click="nextDay()"><i class="fa fa-arrow-right" aria-hidden="true"></i></a>
                                </span>

                                <label for="exampleInputEmail3" style="margin-left:8px!important;">Status:</label>
                                <span class="o-custom-dropdown o-inline-block">
                                    <select class="form-control" v-model="statusDailySchedule" @change="onStatusChanged">
                                    <option value="all">All</option>
                                        <option value="confirmed">Confirmed</option>
                                        <option value="unassigned">Unassigned</option>
                                        <option value="unconfirmed">Unconfirmed</option>
                                    </select>
                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </span>

                                <label for="exampleInputEmail3" style="margin-left:8px!important;">Skills:</label>
                                <el-select
                                style="width:475px!important;height:auto!important;"
                                v-model="skills"
                                filterable
                                multiple
                                collapse-tags
                                @change="onChangeSkills"
                                placeholder="Select">
                                <!-- <el-option label="All" :value="0"></el-option> -->
                                <el-option
                                  v-for="skill in skillOptions"
                                  :key="skill.id"
                                  :label="skill.name"
                                  :value="skill.id">
                                </el-option>
                              </el-select>
                              <!-- <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span> -->

                              <label for="exampleInputEmail3" style="margin-left:8px!important;">Sort:</label>
                              <span class="o-custom-dropdown o-inline-block">
                                <!-- sort:- job_last/seniority/fname_desc -->
                                    <select class="form-control" style="width:200px;" v-model="sort" place @change="onSortChanged">
                                        <option value="seniority">Seniority</option>
                                        <option value="fname_desc">Last,First</option>
                                        <option value="job_last">Job #, Last</option>
                                    </select>
                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                              </span>
                              <a @click="getRdlxJsonUrl()" href="javascript: void(0)" class="c-common-btn c-solid-btn--small print-button" v-if="selectedReportId">Print Report</a>
                             </div>
                        </div>
                    </div>
                </div>


                <div v-if="loading" v-loading="loading" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" style="height: 80px; z-index:10">
                    <div class="calls-table-row">
                        <div class="calls-table-cell" style="height: 100px;">
                            <div class="o-accordion-subtext o-rowtable-text">
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="componentName=='DailySchedule'" class="o-scheduleTable o-scheduleTable--daily">
                    <div v-for="(schedule,index) in scheduleList" :key="index" class="o-skill-box c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 call-list-table-align o-schedule-table">

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Employee</span></p>
                                    <p>{{(schedule.employee && schedule.employee.employable)?schedule.employee.employable.last_name+", "+schedule.employee.employable.first_name:"--"}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Sen.</span></p>
                                    <p>{{ (schedule.employee) && schedule.employee.seniority ? getRoundOffSkillSeniority(schedule.employee.seniority) : "--" }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Event</span></p>
                                    <p><a href="javascript: void(0)">{{`${schedule.job_number} # ${schedule.title}` }}</a></p>
                                </div>
                            </div>
                        </div>
                        <div class="schedule-box-left table-td-border-right">

                            <div class="skill-details">
                                <div class="skill-details-box">
                                    <div class="">
                                        <div class="schedule-details-box text-center">
                                            <p><span>Start -  End</span></p>
                                            <p>{{getTime(schedule.start)+' - '+getTime(schedule.end) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="skill-details-box">
                                    <div class="">
                                        <div class="skill-details-box text-center">
                                            <p><span>End time</span></p>
                                            <p>{{getTime(schedule.end)}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Position:</span></p>
                                    <p v-if="schedule.skill&&schedule.skill.name">{{ schedule.skill.name }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Status:</span></p>
                                    <div v-if="schedule.status&&schedule.status.name">
                                        {{ schedule.status.name  }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Time:</span></p>
                                    <div v-if="schedule.status&&schedule.status.updated_at">
                                        {{ getTime(schedule.status.updated_at)  }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="schedule-box-left table-td-border-right">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <p><span>Notes:</span></p>
                                    <div v-if="schedule.notes">
                                        {{ schedule.notes  }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="schedule-box-left">
                            <div class="skill-details">
                                <div class="schedule-details-box">
                                    <a :class="{'isDisabled':!getPower('phoneSheetActions')}" href="javascript: void(0)" v-if="schedule.status&&schedule.status.name!='Unassigned'&&schedule.status.name!='Confirmed'" @click="goToPhoneSheet(schedule.job_id)" class="c-common-btn c-common-btn--small">Phone Sheet</a>
                                    <a :class="{'isDisabled':!getPower('phoneSheetActions')}" href="javascript: void(0)" v-if="schedule.status&&schedule.status.name=='Unassigned'" @click="goToCalls(schedule.job_id)" class="c-common-btn c-common-btn--small">View Calls</a>
                                    <a  :class="{'isDisabled':!getPower('phoneSheetActions')}" href="javascript: void(0)" v-if="schedule.status&&schedule.status.name=='Confirmed'" @click="declineCall(schedule)" class="c-common-btn c-common-btn--small">Call Out</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="scheduleList.length == 0 && afterAPI" class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                        <div class="col-md-12 no-job-dispaly">
                           <i class="fa fa-frown-o" aria-hidden="true"></i>
                           <br />
                            No Data Stored
                        </div>
                    </div>
                </div>
                <div v-else-if="componentName=='AllEmployees'" class="o-scheduleTable o-scheduleTable--daily">
                    <dailyScheduleAllEmployees :componentName="componentName" :date="currentDate" :search="searchData" :status="statusDailySchedule" :sort="sort" :skills="skills"  />
                </div>
            </div>
        </div>

        <modal name="add-note-callout-decline" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom" @closed="openCloseAddNoteModal('close', null)">
            <div tabindex="-1" role="dialog" >
                <div role="document">
                    <div class="modal-content">
                        <div class="modal-header text-center">
                            <button @click="openCloseAddNoteModal('close', null)" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 class="modal-title" v-if="selectedJob">Add Note </h1>
                        </div>

                        <div class="modal-body mt-15" v-if="addNoteDialog">
                            <!-- <p>{{ selectedJob.venue }}</p> -->
                            <form>
                            <div class="row">
                                <div class="col-sm-12 o-no-padding">
                                    <div class="col-md-5 o-right-no-padding o-calender-area">
                                        <div class="o-calls-table">
                                            <div class="o-calender-details-list">
                                                <el-form :model="addNoteDialogForm">
                                                    <el-form-item label="Note">
                                                    <el-input v-model="addNoteDialogForm.note" autocomplete="off"></el-input>
                                                    </el-form-item>
                                                </el-form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </form>
                        </div>

                        <div class="modal-footer text-center">
                             <span slot="footer" class="dialog-footer">
                                <el-button @click="openCloseAddNoteModal('close', null)">Cancel</el-button>
                                <el-button type="primary" :disabled="disabled" @click="performCalloutDeclineActions(callData, addNoteDialogForm.note)">Callout</el-button>
                            </span>
                        </div>

                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import dateTimeConvert from '../timeConvert&Compare';
    import dailyScheduleAllEmployees from './dailyScheduleAllEmployees.vue'
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../services.js';
    import { generateReportAsync } from '../reportTaskPoller';
    import { global } from '../global.js';

    export default {
        components: {
            dailyScheduleAllEmployees
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userToken2: 'userToken2',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                subDomain: 'getSubdomain',
                userName: "userName",
                userFirstName: "userFirstName",
                userFullName: "userFullName",
                employeeId: 'employeeId'
            }),
            // filterDailySchedule() {
            //     if (this.statusDailySchedule == "all") {
            //         return this.scheduleList;
            //     } else {
            //         return this.scheduleList.filter((schedule) => {
            //             return schedule.status.name.match(this.statusDailySchedule);

            //         });
            //     }
            // },
            // getDateForAllEmployees() {
            //     console.log(this.currentDate);
            //     return moment(this.currentDate).format('YYYY-MM-DD');
            // },
        },
        data() {
            return {
                componentName:'DailySchedule',
                disabled: false,
                total_jobs: 0,
                total_calls: 0,
                selectedJob: null,
                loading: false,
                callData: null,
                addNoteDialog: false,
                addNoteDialogForm: {
                    note: ''
                },
                action: null,
                scheduleList: [],
                afterAPI: false,
                currentDate: "",
                statusDailySchedule: "all",
                searchData:'',
                daily_report_date: "",
                loadingModal:false,
                reportList: [],
                selectedReportId: null,
                skills: [''],
                skillOptions: [],
                sort: 'seniority'
            }
        },
        methods: {

            async toggleComponent(component) {
                this.componentName = component;
                if(component == 'DailySchedule') {
                    await this.getDailyScheduleList();
                }
                console.log(this.componentName)
            },
            getAllSkills() {
                this.skillOptions = [];
                let tempObj = {
                    id: '',
                    name: 'ALL'
                }
                this.skillOptions.push(tempObj);
                let tempSkills = [];
                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    tempSkills = res.data.result;
                    tempSkills.forEach((obj) => {
                        this.skillOptions.push(obj);
                    })
                }).catch((err) => {
                    console.log(err);
                });
            },
            getRoundOffSkillSeniority(seniorityVal) {
                if(seniorityVal && seniorityVal != '') {
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            openDailyReportModal(id) {
                this.daily_report_date = moment().format('YYYY-MM-DD');
                this.$modal.show(id);
            },

            closeModal(id){
                this.$modal.hide(id);
            },

            async getReportList(){
                await service.get('superadmin/getAllRoleBasedActiveReports', {
                    'Authorization': this.userToken,
                    'userId': this.userID,
                    'employeeId': this.employeeId
                }).then((res) => {
                    this.reportList = res.data.result;
                    this.fetchSelectedDailyReportId();
                }).catch((err) => {
                    console.log(err);
                });

            },

            fetchSelectedDailyReportId() {
                let record = this.reportList.find((item) => item.type == 'daily_schedule');
                this.selectedReportId = record ? record.id : null;
            },

            async getRdlxJsonUrl(){
                this.daily_report_date = moment(this.currentDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
                this.$Progress.start();
                this.loadingModal=true;
                try {
                    const task = await generateReportAsync('active_report', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }, {
                        report_id: this.selectedReportId,
                        type: 'daily_schedule',
                        dates: moment(this.currentDate).format('YYYY-MM-DD'),
                        status: this.statusDailySchedule,
                        skills: this.skills.length ? this.skills : [],
                        sort: this.sort,
                    });
                    this.loadingModal=false;
                    this.closeModal('daily-report-popup');
                    let redirectUrl = dateTimeConvert.getEmployeeReportUrl('jobReports/', task.result_meta.active_report.rdlx_template, task.gcs_path);
                    redirectUrl = redirectUrl+'&token='+btoa(this.userToken2)+"&api_base_url="+btoa(global[0].BASE_URL);
                    this.$Progress.finish();
                    window.open(redirectUrl, "_blank");
                } catch (err) {
                    this.loadingModal=false;
                    this.closeModal('daily-report-popup');
                    this.$Progress.finish();
                    this.$notify.error({ title: 'Error', message: err.message || 'Failed to generate report' });
                }
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            declineCall(call){
                this.action = "Callout";
                this.callData = call;
                this.$confirm('Are you sure ?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.addNoteDialog = true;
                    this.openCloseAddNoteModal('open', call);
                }).catch(() => {

                });
            },
            openCloseAddNoteModal(type, call){
                this.addNoteDialog = true;
                this.callData = call;
                if(type == 'open'){
                    this.addNoteDialog = true;
                    this.$modal.show("add-note-callout-decline");
                }else{
                    this.addNoteDialog = false;
                    this.$modal.hide("add-note-callout-decline");
                }
            },
            async performCalloutDeclineActions(call,value) {
                await this.openAddNotePromptCallOut(call,value);
            },
            async openAddNotePromptCallOut(call,value) {
                this.disabled = true;
                var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                };
                activityID = JSON.stringify(activityID);
                await service.post('call/' + call.id + '/callout', {
                        user_id: this.userID,
                        activity: activityID,
                        note_content: value,
                    }, {
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.disabled = false;
                        this.$Progress.finish();
                        this.addNoteDialog = false;
                        this.$modal.hide("add-note-callout-decline");
                        this.addNoteDialogForm.note = "";
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Called Out successfully.',
                            type: 'success'
                        });
                        this.$router.push({
                            path: "/viewCalls/"+btoa(call.job_id)
                        });
                    }).catch((err) => {
                        this.disabled = false;
                        console.log(err);
                        this.$Progress.finish();
                    });
            },

            goToCalls(id){
                this.$store.dispatch('setSelectedCallList', 'individual');
                this.$router.push({
                    path: `/viewCalls/`+btoa(id)
                });
            },
            previousDay(){
                this.currentDate= moment(this.currentDate).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'); //new Date(this.currentDate).setDate(new Date(this.currentDate).getDate() - 1);
                this.getDailyScheduleList();
            },
            async onDateChange(){
                this.currentDate = moment(this.currentDate).format('YYYY-MM-DD HH:mm:ss');
                if(this.componentName=='DailySchedule') {
                    await this.getDailyScheduleList();
                }
            },
            onChangeSkills(val) {
                if(val.length>1&&val[0]==''){
                    this.skills.splice(0,1);
                }else {
                    let index = val.findIndex((item)=>item=='');
                    if(index>=0) {
                        this.skills = [];
                        this.skills.push('');
                    }
                }
                if(val==[]) {
                    this.skills.push('');
                }
                this.getDailyScheduleList();
            },
            async onStatusChanged() {
                await this.getDailyScheduleList();
            },
            async onSortChanged() {
                console.log(this.sort);
                if(this.componentName=='DailySchedule') {
                    await this.getDailyScheduleList();
                }
            },
            async nextDay(){
                this.currentDate = moment(this.currentDate).add(1, 'days').format('YYYY-MM-DD HH:mm:ss'); //new Date(this.currentDate).setDate(new Date(this.currentDate).getDate() + 1);
                if(this.componentName=='DailySchedule') {
                    await this.getDailyScheduleList();
                }
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },
            getDate(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },
            getDateForStatus(dateTime) {
                var date = new Date(dateTime);
                var day = (date.getDate() < 10) ? ("0" + date.getDate()) : date.getDate();
                var month = (date.getMonth() < 10) ? ("0" + date.getMonth()) : date.getMonth();
                var year = date.getFullYear();
                date = year + "/" + month + "/" + day;
                return date;
            },
            goToPhoneSheet(id) {
                this.$router.push({
                    'path': '/phoneSheet/'+btoa(id)
                })
            },
            getDateInFormat(dateTime){
                return moment(dateTime).format('dddd DD, MMM YYYY');
            },
            async getDailyScheduleList(){
                if(this.componentName=='DailySchedule'){
                    this.scheduleList = [];
                    this.$Progress.start();
                    this.loading=true;
                    this.afterAPI=false;
                    let skillCheck = true;
                    if(this.skills.length==1&&this.skills[0]=='') {
                        skillCheck = false;
                    }
                    await service.get('call/dailySchedule', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'dates': moment(this.currentDate).format('YYYY-MM-DD'),
                        'search': this.searchData,
                        'status': this.statusDailySchedule,
                        'skills': this.skills.length&&skillCheck?this.skills:[],
                        'sort': this.sort
                    })
                    .then((res) => {
                        this.scheduleList = res.data.result.schedule_data;
                        this.total_jobs = res.data.result.total_jobs;
                        this.total_calls = res.data.result.total_calls;
                        this.$Progress.finish();
                        this.afterAPI = true;
                        this.loading=false;
                    }).catch((err) => {
                        console.log(err);
                        this.afterAPI = true;
                        this.loading=false;
                    });
                }else {
                    // Just Relax no work in this component to do.
                }
            }
        },
        created() {
            this.currentDate = moment().format('YYYY-MM-DD HH:mm:ss');
            this.getDailyScheduleList();
            this.getReportList();
            this.getAllSkills();
        }
    }

</script>
<style scoped>
.marlef-5{
    margin-left:5px!important;
}
.marrig-5{
    margin-right:5px!important;
}
.o-daily-schedule-navigation span{
    margin-right: 0!important;
    margin-left: 0!important;
}
.pad-25{
    padding-top:25px;
}

.width-220 {
    width: 220px!important;
}
.ml-15 {
    margin-left:15px;
}
.print-button{
    background-color: #1AB677;
    color: #ffffff;
}
</style>

